<template>
  <layout-bigscreen nav_top="0">
    <div
      id="antdVue"
      ref="antdVue"
      :style="themeColorInit(themeColorConfig)"
      class="zoom_bg_color"
      style="width: 100%; height: 100%"
    >
      <div class="antdVue" :style="{ ...calculateStyles }">
        <div class="flex flex-direction align-start benben-flex-layout w-100 h-100">
          <div
            v-if="AI_dialog_show"
            @click.self="AI_dialog_show = false"
            class="w-100 h-100 flex justify-center align-center"
            style="position: fixed; top: 0; left: 0; background: rgba(0, 0, 0, 0.3); z-index: 99999"
          >
            <div
              class="position-relative flex justify-center"
              style="
                background: url(https://ttk-saas.oss-cn-beijing.aliyuncs.com/m4698/2024-06-21/1872835f5691d07c47863b7a8ed98be2.png)
                  center center / 100% 100% no-repeat;
                width: 566px;
                height: 618px;
              "
            >
              <div v-if="API_loading" class="flex flex-direction align-center justify-center">
                <div class="loading flex align-center justify-around mg-b-20" style="width: 40px">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span style="font-family: PingFang SC, PingFang SC; font-weight: 400; font-size: 16px; color: #fff"
                  >数据解读，稍后揭晓！</span
                >
              </div>
              <div
                class="position-absolute AI_content"
                style="top: 150px; padding: 0 40px; color: #fff; height: 270px; overflow-y: auto; font-size: 16px"
                v-else
                v-html="API_content"
              ></div>

              <img
                class="position-absolute"
                @click="AI_dialog_show = false"
                style="
                  width: 28px;
                  aspect-ratio: 1/1;
                  left: 50%;
                  transform: translateX(-50%);
                  bottom: -40px;
                  cursor: pointer;
                "
                src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240614/02617705959e9789b87f16f6ba719884.png"
                alt=""
              />
            </div>
          </div>
          <div
            class="flex flex-wrap align-center justify-center daping_659_fd0_1 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100 f-c-3 position-relative bg-size-auto"
          >
            <div
              class="flex flex-wrap align-center daping_724_fd0_1_c0 position-absolute t-18"
              v-if="!isEmpty(weather_info.text)"
            >
              <img class="daping_627_fd0_1_c0_c0" :src="weather_info.img_url" />
              <span class="daping_848_fd0_1_c0_c1 t-w-4">{{ weather_info.text }}</span>
              <div class="flex flex-wrap align-center daping_556_fd0_1_c0_c2 bg-size-auto"></div>
              <span class="daping_904_fd0_1_c0_c3 h-10-px t-w-4">{{ weather_info.temperature }}</span>
              <span class="daping_904_fd0_1_c0_c3 h-10-px t-w-4">{{ '℃' }}</span>
            </div>
            <img
              class="daping_495_fd0_1_c1"
              src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/e86a55b2a20775c71c1fb6cc91dd3c1e.png"
            />
            <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">JoeMe平台数据大屏</span>
            <img
              class="daping_542_fd0_1_c3"
              src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/d3adc8fbbce7c9aa2bbd0f8ae8ac5a40.png"
            />
            <div class="flex align-center daping_958_fd0_1_c4 position-absolute">
              <img
                class="daping_210_fd0_1_c4_c0"
                src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/2af63761ef0068fdbbfded13de1d740c.png"
              />

              <benben-real-time
                class="flex align-center justify-center daping_708_random_fd0_1_c4_c1 t-18 t-w-4"
                format="YYYY-MM-DD HH:mm:ss"
                :has_week="true"
                :refresh_interval="500"
                show_title="true"
                title_position="left"
                title_name="标题"
              >
              </benben-real-time>
            </div>

            <benben-full-screen class="flex align-center justify-center daping_900_random_fd0_1_c5 position-absolute a">
            </benben-full-screen>
          </div>
          <a-row class="benben-grid" :gutter="[8, 8]" type="flex">
            <a-col :xs="24" :md="5" :xl="5" :xxl="5">
              <div class="flex flex-wrap align-center pd-t-0 pd-r-0 pd-b-0 pd-l-10 w-100">
                <div class="flex flex-direction align-center daping_692_fd0_2_c0_c0_c0 mg-0 pd-0 w-100">
                  <div
                    class="flex flex-wrap align-center justify-between daping_704_fd0_2_c0_c0_c0_c0 mg-0 pd-t-0 pd-r-0 pd-b-0 pd-l-40 w-100 bg-size-100 h-100 position-relative"
                    style="height: 30px"
                  >
                    <span class="daping_854_fd0_2_c0_c0_c0_c0_c0 f-c-fff t-20 t-w-5">{{ '平台用户年龄分布' }}</span>
                  </div>
                  <div class="flex flex-wrap align-center w-100 h-100">
                    <benben-pie-ring
                      class="w-100 h-100"
                      :field-options="field_options_369314"
                      data_source_type="1"
                      chart_show_type="pie-ring"
                      show_title="false"
                      title_position="left"
                      title_name="标题"
                      :theme_color="theme_color_4277"
                      :chart-option="chartOptions_random_3374"
                    >
                    </benben-pie-ring>
                  </div>
                </div>
                <div class="flex flex-wrap align-center daping_692_fd0_2_c0_c0_c0 mg-0 pd-0 w-100">
                  <div
                    class="flex flex-wrap align-center justify-between daping_181_fd0_2_c0_c0_c1_c0 mg-0 pd-t-0 pd-r-0 pd-b-0 pd-l-40 w-100 bg-size-100"
                  >
                    <span class="daping_854_fd0_2_c0_c0_c0_c0_c0 f-c-fff t-20 t-w-5">{{ '当月用户增长' }}</span>
                  </div>
                  <div class="flex align-center daping_843_fd0_2_c0_c0_c1_c1 w-100 position-relative a">
                    <div id="monthUser" style="width: 100%; height: 200px"></div>
                  </div>
                </div>
                <div class="flex flex-wrap align-center daping_692_fd0_2_c0_c0_c0 mg-0 pd-0 w-100">
                  <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{ '本周报警次数趋势' }}</span>
                  <img
                    class="joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100"
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/7794c5512c6c405dbe9683fb2c49bb73.png"
                  />
                  <div class="flex flex-wrap align-start w-100 h-100">
                    <benben-line-simple
                      class="w-100 h-100"
                      :field-options="field_options_216304"
                      data_source_type="1"
                      chart_show_type="line-simple"
                      show_title="false"
                      title_position="left"
                      title_name="标题"
                      :theme_color="theme_color_4609"
                      :chart-option="chartOptions_random_2137"
                    >
                    </benben-line-simple>
                  </div>
                </div>
              </div>
            </a-col>

            <a-col :xs="24" :md="14" :xl="14" :xxl="14" class="mg-0 h-100">
              <div class="flex flex-direction align-center justify-center mg-0 pd-0 h-100 w-100 position-relative">
                <!-- <div class="flex align-center justify-around mg-0 pd-0 w-100 h-120-px">
                  <div
                    class="flex flex-direction align-center self-center justify-center daping_255_fd0_2_c1_c0_c0_c0 bg-size-100 h-120-px position-relative a"
                  >
                    <div class="flex align-center self-center justify-center daping_851_fd0_2_c0_c0_c0_c1_c0">
                      <benben-light-text
                        class="light-text daping_544_random_fd0_2_c0_c0_c0_c1_c0_c0 t-40 f-c-3"
                        data_source_type="4"
                        chart_show_type="simple-text"
                        :is_abs="false"
                      >
                      </benben-light-text>

                      <span class="daping_288_fd0_2_c0_c0_c0_c1_c0_c1 mg-t-10 mg-r-0 mg-b-0 mg-l-0 f-c-fff t-20">{{
                        topInfo.total
                      }}</span>
                    </div>
                    <span class="daping_298_fd0_2_c0_c0_c0_c1_c1 f-c-fff t-20 t-w-5 position-absolute">{{
                      '平台总用户'
                    }}</span>
                  </div>

                  <div
                    class="flex flex-direction align-center self-center justify-center daping_255_fd0_2_c1_c0_c0_c0 mg-0 bg-size-100 h-120-px position-relative a"
                  >
                    <div class="flex align-center self-center justify-center daping_851_fd0_2_c0_c0_c0_c1_c0">
                      <benben-light-text
                        class="light-text daping_544_random_fd0_2_c0_c0_c0_c1_c0_c0 t-40 f-c-3"
                        data_source_type="4"
                        chart_show_type="simple-text"
                        :is_abs="false"
                      >
                      </benben-light-text>

                      <span class="daping_550_fd0_2_c1_c0_c0_c1_c0_c1 f-c-fff t-20">{{ topInfo.totalMess }}</span>
                    </div>
                    <span class="daping_298_fd0_2_c0_c0_c0_c1_c1 f-c-fff t-20 t-w-5 position-absolute">{{
                      '累计报警总数'
                    }}</span>
                  </div>
                  <div
                    class="flex flex-direction align-center self-center justify-center daping_255_fd0_2_c1_c0_c0_c0 mg-0 bg-size-100 h-120-px position-relative a"
                  >
                    <div class="flex align-center self-center justify-center daping_280_fd0_2_c1_c0_c0_c1_c0">
                      <benben-light-text
                        class="light-text daping_757_random_fd0_2_c1_c0_c0_c1_c0_c0 t-40 f-c-fff lh-20-px"
                        data_source_type="4"
                        chart_show_type="simple-text"
                      >
                      </benben-light-text>

                      <span class="daping_550_fd0_2_c1_c0_c0_c1_c0_c1 f-c-fff t-20">{{ topInfo.todayMess }}</span>
                    </div>
                    <span class="daping_298_fd0_2_c0_c0_c0_c1_c1 f-c-fff t-20 t-w-5 position-absolute">{{
                      '当月报警次数'
                    }}</span>
                  </div>

                  <div
                    class="flex flex-direction align-center self-center justify-center daping_255_fd0_2_c1_c0_c0_c0 mg-0 bg-size-100 h-120-px position-relative a"
                  >
                    <div class="flex align-center self-center justify-center daping_851_fd0_2_c0_c0_c0_c1_c0">
                      <benben-light-text
                        class="light-text daping_544_random_fd0_2_c0_c0_c0_c1_c0_c0 t-40 f-c-3"
                        data_source_type="4"
                        chart_show_type="simple-text"
                        :is_abs="false"
                      >
                      </benben-light-text>

                      <span class="daping_550_fd0_2_c1_c0_c0_c1_c0_c1 f-c-fff t-20">{{ topInfo.today }}</span>
                    </div>
                    <span class="daping_298_fd0_2_c0_c0_c0_c1_c1 f-c-fff t-20 t-w-5 position-absolute">{{
                      '当月增加用户'
                    }}</span>
                  </div>
                </div> -->
                <div class="flex flex-direction align-center self-center justify-center flex-sub mg-0 pd-0 w-100 h-100">
                  <div
                    class="flex flex-wrap align-start joefitdaping_625_fd0_1_c1_c0 w-100 bg-size-100 position-relative"
                  >
                    <div class="flex align-center w-100">
                      <div class="flex align-center joefitdaping_154_fd0_1_c1_c0_c0_c0 w-100 position-absolute">
                        <div class="flex flex-direction flex-wrap align-center pd-t-0 pd-r-40 pd-b-0 pd-l-0 w-100">
                          <benben-light-text
                            class="light-text joefitdaping_435_random_fd0_1_c1_c0_c0_c0_c0_c0 f-c-9 t-w-4"
                            style="position: absolute; margin-top: 9%"
                            :field-options="{ data: topInfo.total }"
                            data_source_type="1"
                            chart_show_type="simple-text"
                            :is_abs="false"
                          >
                          </benben-light-text>

                          <span
                            class="joefitdaping_567_fd0_1_c1_c0_c0_c0_c0_c1 f-c-fff t-16 t-w-5"
                            style="position: absolute; margin-top: 15%; margin-left: -36px"
                            >{{ '平台总用户' }}</span
                          >
                        </div>
                        <div
                          class="flex flex-direction flex-wrap align-center joefitdaping_916_fd0_1_c1_c0_c0_c0_c1 w-100"
                        >
                          <benben-light-text
                            class="light-text joefitdaping_435_random_fd0_1_c1_c0_c0_c0_c0_c0 f-c-9"
                            :field-options="{ data: topInfo.totalMess }"
                            data_source_type="1"
                            style="position: absolute; margin-top: 9%"
                            chart_show_type="simple-text"
                            :is_abs="false"
                          >
                          </benben-light-text>

                          <span
                            class="joefitdaping_567_fd0_1_c1_c0_c0_c0_c0_c1 f-c-fff t-16 t-w-5"
                            style="position: absolute; margin-top: 15%; margin-left: 47px"
                            >{{ '累计发出警报数' }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="flex align-center joefitdaping_897_fd0_1_c1_c0_c1 w-100 position-absolute">
                      <div class="flex flex-direction flex-wrap align-center pd-t-0 pd-r-40 pd-b-0 pd-l-0 w-100">
                        <benben-light-text
                          class="light-text joefitdaping_435_random_fd0_1_c1_c0_c0_c0_c0_c0 f-c-9 t-w-4"
                          :field-options="{ data: topInfo.todayMess }"
                          data_source_type="1"
                          chart_show_type="simple-text"
                          style="position: absolute; margin-top: 37%"
                          :is_abs="false"
                        >
                        </benben-light-text>

                        <span
                          class="joefitdaping_567_fd0_1_c1_c0_c0_c0_c0_c1 f-c-fff t-16 t-w-5"
                          style="position: absolute; margin-top: 43%; margin-left: -33px"
                          >{{ '本月报警数' }}</span
                        >
                      </div>
                      <div
                        class="flex flex-direction flex-wrap align-center joefitdaping_916_fd0_1_c1_c0_c0_c0_c1 w-100"
                      >
                        <benben-light-text
                          class="light-text joefitdaping_435_random_fd0_1_c1_c0_c0_c0_c0_c0 f-c-9"
                          :field-options="{ data: topInfo.today }"
                          data_source_type="1"
                          chart_show_type="simple-text"
                          style="position: absolute; margin-top: 37%"
                          :is_abs="false"
                        >
                        </benben-light-text>

                        <span
                          class="joefitdaping_567_fd0_1_c1_c0_c0_c0_c0_c1 f-c-fff t-16 t-w-5"
                          style="position: absolute; margin-top: 43%; margin-left: 50px"
                          >{{ '当月增加用户' }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <a-row class="benben-grid mg-0 w-100" :gutter="[8, 8]" type="flex">
                  <a-col :xs="24" :md="12" :xl="12" :xxl="12">
                    <div class="flex flex-wrap align-center mg-0 pd-0 w-100">
                      <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{ '本周用户增长趋势' }}</span>
                      <img
                        class="joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100"
                        src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/7794c5512c6c405dbe9683fb2c49bb73.png"
                      />
                      <div class="flex flex-wrap align-start w-100 h-100">
                        <benben-line-area-accumul
                          class="w-100 h-100"
                          style="height: 300px"
                          :field-options="field_options_506087"
                          data_source_type="1"
                          chart_show_type="line-area-accumul"
                          show_title="false"
                          title_position="left"
                          title_name="标题"
                          :linear_gradient_color="[
                            { start: 10, color1: 'rgba(255, 140, 25, .7)', color2: 'rgba(255, 140, 25, 0)' },
                            { start: 50, color1: '#23b7e5', color2: '' },
                          ]"
                          :theme_color="theme_color_4066"
                          :chart-option="chartOptions_random_8473"
                        >
                        </benben-line-area-accumul>
                      </div>
                    </div>
                  </a-col>

                  <a-col :xs="24" :md="12" :xl="12" :xxl="12" class="mg-0 h-100-px w-50">
                    <div
                      class="flex flex-direction align-start daping_692_fd0_2_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-auto bdr-16"
                    >
                      <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{ '用户性别占比' }}</span>
                      <img
                        class="joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100"
                        src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/7794c5512c6c405dbe9683fb2c49bb73.png"
                      />
                      <div class="flex flex-wrap align-center w-100 h-100">
                        <benben-pie-ring
                          class="w-100 h-100"
                          style="height: 300px"
                          :field-options="field_options_470002"
                          data_source_type="1"
                          chart_show_type="pie-ring"
                          show_title="false"
                          title_position="left"
                          title_name="标题"
                          :theme_color="theme_color_2585"
                          :chart-option="chartOptions_random_5378"
                        >
                        </benben-pie-ring>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </a-col>

            <a-col :xs="24" :md="5" :xl="5" :xxl="5">
              <div class="flex flex-wrap align-center mg-t-0 mg-r-10 mg-b-0 mg-l-0 w-100">
                <div
                  class="flex flex-direction align-start joefitdaping_641_fd0_2_c0 mg-t-0 mg-r-10 mg-b-0 mg-l-10 w-100 bg-size-auto"
                  style="height: 600px"
                >
                  <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{ '报警信息汇总' }}</span>
                  <img
                    class="joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100"
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/21da90ca613e8dba247fec9e68435246.png"
                  />
                  <div class="flex align-start w-100 h-100">
                    <big-screen-table
                      class="joefitdaping_937_random_fd0_2_c0_c2_c0 w-100"
                      style="color: red; font-size: 14px"
                      :field-options="field_options_567167"
                      data_source_type="1"
                      chart_show_type="big_screen_table"
                      show_title="false"
                      title_position="left"
                      title_name="标题"
                      :show_num="10"
                      play_type="one_num"
                      num_width="10"
                      num_shape="circle"
                      num_top="3"
                      :show_sort="false"
                    >
                    </big-screen-table>
                  </div>
                </div>
              </div>
              <div
                class="flex flex-direction align-start daping_692_fd0_2_c0_c0_c0 joefitdaping_327_fd0_1_c0_c0_c0 mg-r-0 mg-l-0 w-100 bg-size-auto bdr-16"
              >
                <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{ '用户已佩戴设备占比' }}</span>
                <img
                  class="joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100"
                  src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/7794c5512c6c405dbe9683fb2c49bb73.png"
                />
                <div class="flex flex-wrap align-center w-100 h-100">
                  <benben-pie-ring
                    class="w-100 h-100"
                    style="height: 300px"
                    :field-options="field_options_470001"
                    data_source_type="1"
                    chart_show_type="pie-ring"
                    show_title="false"
                    title_position="left"
                    title_name="标题"
                    :theme_color="theme_color_2585"
                    :chart-option="chartOptions_random_5379"
                  >
                  </benben-pie-ring>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </layout-bigscreen>
</template>
<script>
import { bigScreenMixins, receiveNew } from '@/assets/diypaaspc/diy-generate-big-screen-new.js'
import {
  receive,
  benbenSelectDiy,
  benbenFlexNumberBox,
  scrollList,
  treeSelect,
  simpleSelect,
  multipleSelect,
  cascaderForm,
  checkboxForm,
  switchForm,
  messageReply,
  rangePicker,
  handSignature,
  mixinAddTableItem,
  editorForm,
  qiunDataCharts,
  copyText,
  mixinTableItemChange,
  in_array,
  themeColorInit,
  getUrlKey,
  clearDataPass,
  isEmpty,
  treeEdit,
} from '@/assets/diypaaspc/diy-pass-pc.js'
import { provinceForm } from '@/assets/diypaaspc/province_area.js'
import request from '@/utils/request'
import * as echarts from 'echarts'
import 'echarts-gl'
import 'echarts-liquidfill'
import { mapdata } from '@/assets/diypaaspc/mapdata.js'
import layoutBigscreen from '@/components/layoutBigscreen'
import {
  getUserAddData,
  getHomeData,
  getUserAge,
  getWeekData,
  getUseSexrData,
  getRecordList,
  getUserAddDataMonth,
  selectUserWear,
} from '@/api/daping/daping.js'
export default {
  name: 'daping',
  components: {
    layoutBigscreen,
  },
  mixins: [bigScreenMixins],
  data() {
    const themeColorConfig = {
      presetApi: {
        getClassifyOne: '',
        getClassifyTow: '',
        getClassifyShop: '',
      },
      themeType: 0,
      themeConfig: [
        {
          colorConfig: [
            '#333333',
            '#666666',
            '#999999',
            '#ffffff',
            '#0052c7',
            '#F02325',
            '#FC9C3A',
            '#4DC777',
            '#F2CC98',
            '#F2CC66',
          ],
          bgColorConfig: [
            '#EBEDF8',
            '#FFFFFF',
            '#0052c7',
            '#FC9C3A',
            '#FC9fff',
            '#E6F333',
            '#E6F1FE',
            'linear-gradient(301deg, #EBBA7B 0%, #F8D9AD 100%)',
            'linear-gradient(180deg, #F5588E 0%, #F0403C 100%)',
            'linear-gradient(179deg, #FFD033 0%, #F4890E 100%)',
          ],
          bdColorConfig: [
            '#EBEDF8',
            '#FFFFFF',
            '#0052c7',
            '#FC9C3A',
            '#333333',
            '#666666',
            '#999999',
            '#dddddd',
            '#1178F0',
            '#F02325',
          ],
        },
      ],
    }
    receive(this)
    receiveNew(this)
    return {
      themeColorConfig,
      mapdata: mapdata,
      theme_color_4277: ['#F27B60', '#F8A200', '#B0D630', '#6EC890', '#2d3c98', '#6AE7E6', '#0F36A2', '#FC658A'],
      theme_color_3519: ['#FF8C19', '#F8A200', '#B0D630', '#6EC890', '#2d3c98', '#6AE7E6', '#0F36A2', '#FC658A'],
      chartOptions_random_5091: {
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#6E7079',
            },
          },
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 15,
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(255, 255, 255, 0)',
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: false,
          orient: 'horizontal',
          left: 'center',
          top: '',
        },
        grid: {
          left: '2%',
          right: '7%',
          bottom: '3%',
          top: '10%',
          containLabel: true,
        },
        yAxis: {
          scale: true,
          type: 'value',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(57, 82, 150, 1)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 400,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(97, 122, 190, 0.2)',
            },
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(57, 82, 150, 1)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 500,
            rotate: 20,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        seriesSetting: {
          areaStyle: {
            show: true,
          },
          markPoint: {
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                },
              },
            },
            itemStyle: [],
            data: [],
            symbol: 'pin',
            symbolSize: 50,
          },
          markLine: {
            data: [],
            lineStyle: {
              type: 'dashed',
            },
            label: {
              color: '#fff',
            },
            symbol: 'none',
          },
          label: {
            normal: {
              show: true,
              position: 'top',
              fontSize: 12,
              color: 'rgba(255, 140, 25, 1)',
              fontWeight: 500,
            },
          },
        },
      },
      chartOptions_random_3533: {
        tooltip: {
          show: true,
          autoToolTip: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 15,
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(255, 0, 0, 0)',
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: false,
          orient: 'horizontal',
          left: 'center',
          top: '',
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '3%',
          top: '10%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 500,
            rotate: 20,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6E7079',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 400,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
          },
        },
        barSetting: {
          barWidth: 16,
          markPoint: {
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                },
              },
            },
            itemStyle: [],
            data: [{ name: '1', value: 10 }],
            symbol: 'pin',
            symbolSize: 50,
          },
          label: {
            normal: {
              show: true,
              position: 'top',
              fontSize: 12,
              color: '#fff',
              fontWeight: 500,
            },
          },
          markLine: {
            label: {
              color: '#fff',
            },
            symbol: 'none',
            lineStyle: {
              type: 'dashed',
            },
            data: [],
          },
        },
      },

      theme_color_6019: ['#F27B60', '#F8A200', '#B0D630', '#6EC890', '#2d3c98', '#6AE7E6', '#0F36A2', '#FC658A'],
      theme_color_4804: ['#F27B60', '#F8A200', '#B0D630', '#6EC890', '#2d3c98', '#6AE7E6', '#0F36A2', '#FC658A'],
      theme_color_2280: [
        '#24cbff',
        '#9000ff',
        '#484cdc',
        '#711d8e',
        '#2d3c98',
        '#3f8bd8',
        '#2e33d1',
        '#1589ff',
        '#5c4ac9',
      ],
      chartOptions_random_6321: {
        tooltip: {
          show: true,
          autoToolTip: false,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'inherit',
            fontSize: 14,
          },
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: true,
          orient: 'horizontal',
          left: 'center',
          top: '',
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '0%',
          top: '15%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6E7079',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 400,
            rotate: 0,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6E7079',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 400,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        barSetting: {
          barWidth: 10,
          markPoint: {
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                },
              },
            },
            itemStyle: [],
            data: [
              {
                type: 'max',
                name: '最大值',
              },
            ],
            symbol: 'pin',
            symbolSize: 50,
          },
          label: {
            normal: {
              show: true,
              position: 'right',
              fontSize: 16,
              color: '#fff',
            },
          },
          itemStyle: {
            borderRadius: [5, 5, 5, 5],
          },
          markLine: [],
        },
      },
      chartOptions_random_8939: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'inherit',
            fontSize: 14,
          },
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: true,
          orient: 'horizontal',
          left: 'center',
          top: '0%',
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '0%',
          top: '15%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6E7079',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 400,
            rotate: 0,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6E7079',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 400,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        seriesSetting: {
          markPoint: {
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                },
              },
            },
            itemStyle: [],
            data: [
              {
                type: 'max',
                name: 'Max',
              },
              {
                type: 'min',
                name: 'Min',
              },
            ],
            symbol: 'pin',
            symbolSize: 50,
          },
          markLine: {
            data: [
              {
                type: 'average',
                name: 'Avg',
              },
            ],
            lineStyle: {
              type: 'dashed',
            },
            label: {
              color: '#fff',
            },
            symbol: 'none',
          },
          label: {
            normal: {
              show: false,
              position: 'top',
              fontSize: 14,
              color: '#fff',
            },
          },
        },
      },
      theme_color_6990: [
        '#24cbff',
        '#9000ff',
        '#484cdc',
        '#711d8e',
        '#2d3c98',
        '#3f8bd8',
        '#2e33d1',
        '#1589ff',
        '#5c4ac9',
      ],
      chartOptions_random_3374: {
        seriesSetting: {
          center: ['40%', '50%'],
          radius: ['50%', '30%'],
          itemStyle: {
            borderColor: '',
            borderWidth: '',
            borderRadius: '',
          },
          startAngle: '',
          type: 'pie',
          label: {
            color: '#fff',
          },
        },
        labelSetting: {
          label: {
            color: '#fff',
            show: true,
            emphasis: {
              show: false,
              textStyle: {
                fontSize: 14,
                color: '#fff',
              },
              rich: {
                a: {
                  fontSize: 14,
                },
              },
            },
          },
          labelLine: {
            show: true,
          },
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: true,
          orient: 'vertical',
          left: 'right',
          top: '',
        },
        tooltip: {
          show: true,
          autoToolTip: false,
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'inherit',
            fontSize: 14,
          },
        },
      },
      chartOptions_random_8943: {
        tooltip: {
          show: true,
          autoToolTip: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 15,
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(255, 0, 0, 0)',
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: false,
          orient: 'horizontal',
          left: 'center',
          top: '',
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '4%',
          top: '15%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 500,
            rotate: 20,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axisLabel: {
            show: true,
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 14,
            fontWeight: 500,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
          },
        },
        barSetting: {
          barWidth: 16,
          markPoint: {
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                },
              },
            },
            itemStyle: [],
            data: [],
            symbol: 'pin',
            symbolSize: 50,
          },
          label: {
            normal: {
              show: true,
              position: 'top',
              fontSize: 12,
              color: 'rgba(0, 254, 137, 1)',
              fontWeight: 500,
            },
          },
          itemStyle: {
            borderRadius: [5, 5, 5, 5],
          },
          markLine: {
            label: {
              color: '#fff',
            },
            symbol: 'none',
            lineStyle: {
              type: 'dashed',
            },
            data: [],
          },
        },
      },
      isFullScreen: false,
      big_screen_global_query: {
        screen_global_time_range_type: '5',
        screen_global_time_custom_time: '',
        screen_global_dept: '',
        screen_global_user: '',
      },
      saizhuge_api_loaded: false,
      school_info: {},
      weather_info: {},
      weather_data: [
        {
          name: '晴',
          code: '0',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png',
        },
        {
          name: '夜晚晴',
          code: '1',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png',
        },
        {
          name: '晴',
          code: '2',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png',
        },
        {
          name: '夜晚晴',
          code: '3',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png',
        },
        {
          name: '多云',
          code: '4',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/937ea42d4d54677a960419fc926d2308.png',
        },
        {
          name: '晴间多云',
          code: '5',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png',
        },
        {
          name: '晴间多云',
          code: '6',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png',
        },
        {
          name: '大部多云',
          code: '7',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8c1710ce88d626dad374865cc5cc285d.png',
        },
        {
          name: '大部多云',
          code: '8',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8e47c4a733b6ea39aa94ea362bc942fa.png',
        },
        {
          name: '阴',
          code: '9',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/b8a945d068a4c968e5c05e023a67571f.png',
        },
        {
          name: '阵雨',
          code: '10',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2987ff71ec8f90fdffa1c0114e13b1f9.png',
        },
        {
          name: '雷阵雨',
          code: '11',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/751a274ee37d368cd45471edc5b35411.png',
        },
        {
          name: '雷阵雨伴有冰雹',
          code: '12',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/2c7657970388a04e29049a23a0046c56.png',
        },
        {
          name: '小雨',
          code: '13',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/6b02916ef905c0f100e3e6d4bf4c4ff0.png',
        },
        {
          name: '中雨',
          code: '14',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/cc26fd0d1cda78eda4b53d85718b8803.png',
        },
        {
          name: '大雨',
          code: '15',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/1598c140199a349d9ec4aed4482f0cf1.png',
        },
        {
          name: '暴雨',
          code: '16',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png',
        },
        {
          name: '大暴雨',
          code: '17',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b460fe42bb0e8dcbc177b5d6ef5b3c30.png',
        },
        {
          name: '特大暴雨',
          code: '18',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png',
        },
        {
          name: '冻雨',
          code: '19',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/121096065da289cc9ebf23c778c8a4e8.png',
        },
        {
          name: '雨夹雪',
          code: '20',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d9c47f9707616842680ba38e1c8e4d43.png',
        },
        {
          name: '阵雪',
          code: '21',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/af6e554f62f546c76b3b495df7f36eb2.png',
        },
        {
          name: '小雪',
          code: '22',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/71744d3bd3230b10f5d09666a76657ea.png',
        },
        {
          name: '中雪',
          code: '23',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a29d1ac31de2a2cdaecfb4c579cdf928.png',
        },
        {
          name: '大雪',
          code: '24',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/62145c7aea6a3e65c5f1dc8d84f5c92d.png',
        },
        {
          name: '暴雪',
          code: '25',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/50946c87ed7c0e4c471d7cb0310115c3.png',
        },
        {
          name: '浮尘',
          code: '26',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/46258a78adc3acf03d0186836e89b798.png',
        },
        {
          name: '扬沙',
          code: '27',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a2440c63509d48eb1fa45804c6476f7d.png',
        },
        {
          name: '沙尘暴',
          code: '28',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/9a80471d8001ea814aa4206d3feda602.png',
        },
        {
          name: '强沙尘暴',
          code: '29',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/da4066fc0584850d72ec402894765b2d.png',
        },
        {
          name: '雾',
          code: '30',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/4cf7128b075acfd65af6ea175f7240ce.png',
        },
        {
          name: '霾',
          code: '31',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/c6325f4ef718e9aef9dbff86e2d28817.png',
        },
        {
          name: '风',
          code: '32',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/dccb4227577c4f0e51c6b9b16fa75af1.png',
        },
        {
          name: '大风',
          code: '33',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b1d9445881a4a9d0b1471f831d3800c8.png',
        },
        {
          name: '飓风',
          code: '34',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d58120ad96b2b4df9f4ffb35dc07c3c7.png',
        },
        {
          name: '热带风暴',
          code: '35',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/3ca919f2ae75739b3196460dfffdd405.png',
        },
        {
          name: '龙卷风',
          code: '36',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png',
        },
        {
          name: '冷',
          code: '37',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png',
        },
        {
          name: '热',
          code: '38',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d33c81b9f8772998d9bba7d3ea52acb0.png',
        },
        {
          name: '未知',
          code: '99',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/db353a99b557f85968a262210c69f0d7.png',
        },
      ],
      all_discount_user: [],
      discount_goods_cate: {
        chart_data: [],
        value: '',
        name: '',
      },
      team_distributor_list: {
        table_title: [],
        table_data: [],
      },
      user_distributor_data: {
        table_title: [],
        table_data: [],
      },
      AI_dialog_show: '',
      API_loading: '',
      AI_config_data: [],
      viewSource: 'PC',
      big_screen_global_config: {
        is_screen_global_time: false,
        is_screen_global_dept: false,
        is_screen_global_user: false,
      },
      designWidth: 1920,
      designHeight: 1080,
      calculateStyles: {},
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      timerW: false,
      timerH: false,
      page_scale: 1,
      field_options_369314: {},
      field_options_567167: {},
      field_options_470002: {},
      field_options_470001: {},
      chartOptions_random_5378: {
        seriesSetting: {
          center: ['40%', '50%'],
          radius: ['0%', '60%'],
          itemStyle: {
            borderColor: '',
            borderWidth: '',
            borderRadius: '',
          },
          startAngle: '',
          type: 'pie',
          label: {
            color: '#fff',
          },
        },
        labelSetting: {
          label: {
            color: '#fff',
            show: false,
            emphasis: {
              show: false,
              textStyle: {
                fontSize: 14,
                color: '#fff',
              },
              rich: {
                a: {
                  fontSize: 14,
                },
              },
            },
          },
          labelLine: {
            show: true,
          },
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
          },
          show: true,
          orient: 'vertical',
          left: '75%',
          top: 'middle',
        },
        tooltip: {
          show: true,
          autoToolTip: true,
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 15,
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(255, 0, 0, 0)',
        },
      },
      chartOptions_random_5379: {
        seriesSetting: {
          center: ['40%', '50%'],
          radius: ['0%', '60%'],
          itemStyle: {
            borderColor: '',
            borderWidth: '',
            borderRadius: '',
          },
          startAngle: '',
          type: 'pie',
          label: {
            color: '#fff',
          },
        },
        labelSetting: {
          label: {
            color: '#fff',
            show: false,
            emphasis: {
              show: false,
              textStyle: {
                fontSize: 14,
                color: '#fff',
              },
              rich: {
                a: {
                  fontSize: 14,
                },
              },
            },
          },
          labelLine: {
            show: true,
          },
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
          },
          show: true,
          orient: 'vertical',
          left: '75%',
          top: 'middle',
        },
        tooltip: {
          show: true,
          autoToolTip: true,
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 15,
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(255, 0, 0, 0)',
        },
      },
      theme_color_2585: ['#FF5A67', '#11F6F2', '#FF9D00', '#FFC72E', '#00F496', '#00B1FF', '#0F36A2', '#FC658A'],
      theme_color_4066: ['#FF8C19', '#F8A200', '#B0D630', '#6EC890', '#2d3c98', '#6AE7E6', '#0F36A2', '#FC658A'],
      chartOptions_random_8473: {
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 15,
          },
          autoToolTip: true,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(0, 0, 0, 0)',
        },

        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: false,
          orient: 'horizontal',
          left: 'center',
          top: '',
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: 2,
          top: '10%',
          containLabel: true,
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 400,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
          },
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 400,
            rotate: 0,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        seriesSetting: {
          areaStyle: {
            show: true,
          },
          markPoint: {
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                },
              },
            },
            itemStyle: [],
            data: [],
            symbol: 'pin',
            symbolSize: 50,
          },
          markLine: {
            data: [],
            lineStyle: {
              type: 'dashed',
            },
            label: {
              color: '#fff',
            },
            symbol: 'none',
          },
          label: {
            normal: {
              show: false,
              position: 'top',
              fontSize: 14,
              color: 'inherit',
            },
          },
        },
      },
      field_options_506087: {},
      topInfo: {},
      field_options_8943: {},
      field_options_216304: {},
      theme_color_4609: ['#60F262', '#F88000', '#B0D630', '#6EC890', '#2d3c98', '#6AE7E6', '#0F36A2', '#FC658A'],
      chartOptions_random_2137: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 15,
          },
          show: true,
          autoToolTip: true,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(255, 0, 0, 0)',
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: false,
          orient: 'horizontal',
          left: 'center',
          top: '',
        },
        grid: {
          left: '1%',
          right: '2%',
          bottom: '0%',
          top: '10%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 500,
            rotate: 0,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 500,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
          },
        },
        seriesSetting: {
          markPoint: {
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                },
              },
            },
            itemStyle: [],
            data: [],
            symbol: 'pin',
            symbolSize: 50,
          },
          markLine: {
            data: [],
            lineStyle: {
              type: 'dashed',
            },
            label: {
              color: '#fff',
            },
            symbol: 'none',
          },
          label: {
            normal: {
              show: false,
              position: 'top',
              fontSize: 14,
              color: 'inherit',
            },
          },
        },
      },
    }
  },
  filters: {},
  created() {
    if (getUrlKey('viewSource')) {
      this.viewSource = getUrlKey('viewSource')
    }
    this.getUserAge()
    this.getLargeScreen()
    this.getRecordList()
    this.getUseSexrData()
    this.getUserAddData()
    this.getHomeData()
    this.getUserAddDataMonth()
    this.getWeekData()
    this.selectUserWear()
  },
  mounted() {
    let that = this
    window.onresize = () => {
      // that.screenWidth = that.$refs.antdVue.offsetWidth
      // that.screenHeight = that.$refs.antdVue.offsetHeight
      that.handleResize()
    }
    this.$nextTick(() => {
      that.handleResize()
      this.initMonthUser()
    })
  },
  computed: {
    imgList() {
      let obj = {}
      this.AI_config_data.map((item) => {
        obj[item.chart_id] = item
      })
      return obj
    },
  },
  watch: {
    screenWidth(val) {
      if (!this.timerW) {
        let that = this
        // that.screenWidth = val;
        this.timerW = true
        that.handleResize()
        setTimeout(function () {
          that.timerW = false
        }, 400)
      }
    },
    screenHeight(val) {
      if (!this.timerH) {
        let that = this
        // that.screenHeight = val;
        this.timerH = true
        that.handleResize()
        setTimeout(function () {
          that.timerH = false
        }, 400)
      }
    },
  },
  methods: {
    copyText,
    mixinTableItemChange,
    in_array,
    themeColorInit,
    isEmpty,
    //统一获取自定义接口
    get_diy_api_page() {},
    getUserAge() {
      getUserAge().then((response) => {
        this.field_options_369314 = {
          series: [
            {
              data: response.data,
            },
          ],
        }
      })
    },
    getHomeData() {
      getHomeData().then((response) => {
        this.topInfo = response.data
      })
    },
    getUseSexrData() {
      getUseSexrData().then((response) => {
        this.field_options_470002 = {
          series: [
            {
              data: response.data,
            },
          ],
        }
      })
    },
    getUserAddData() {
      getUserAddData().then((response) => {
        this.field_options_506087 = {
          xAxis: {
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
          },
          series: [
            {
              name: '',
              data: response.data,
              type: 'line',
              areaStyle: [],
              smooth: true,
            },
          ],
        }
      })
    },
    getRecordList() {
      getRecordList().then((response) => {
        console.log('getRecordList', response)
        this.field_options_567167 = {
          columns: [
            {
              name: '用户名称',
              prop: 'nickname',
            },
            {
              name: '用户手机号',
              prop: 'mobile',
            },
            {
              name: '报警内容',
              prop: 'dataType',
            },
            {
              name: '异常时间',
              prop: 'createTime',
              accuracy: 1,
            },
          ],
          rows: response.data,
        }
      })
    },
    //线数据
    lineData() {
      let toolTipData = [
        {
          name: '湖南',
          value: 5,
          areas: ['长沙', '株洲', '益阳'],
        },
        {
          name: '安徽',
          value: 3,
          areas: ['合肥', '芜湖'],
        },
        {
          name: '河南',
          value: 3,
          areas: ['郑州', '周口'],
        },
        {
          name: '山东',
          value: 80,
          areas: ['济南', '青岛', '淄博', '烟台', '威海', '临沂'],
        },
        {
          name: '四川',
          value: 35,
          areas: ['成都', '攀枝花', '乐山', '泸州'],
        },
        {
          name: '云南',
          value: 27,
          areas: ['昆明', '玉溪', '丽江', '普洱', '临沧'],
        },
        {
          name: '黑龙江',
          value: 13,
          areas: ['哈尔滨', '鹤岗', '黑河', '绥化', '大庆', '佳木斯'],
        },
        {
          name: '甘肃',
          value: 42,
          areas: ['兰州', '嘉峪关', '天水', '酒泉'],
        },
        {
          name: '西藏',
          value: 74,
          areas: [],
        },
      ]
      let geoCoordMap = {
        黑龙江: [127.9688, 45.368],
        内蒙古: [110.3467, 41.4899],
        吉林: [125.8154, 44.2584],
        北京市: [116.4551, 40.2539],
        辽宁: [123.1238, 42.1216],
        河北: [114.4995, 38.1006],
        天津: [117.4219, 39.4189],
        山西: [112.3352, 37.9413],
        陕西: [109.1162, 34.2004],
        甘肃: [103.5901, 36.3043],
        宁夏: [106.3586, 38.1775],
        青海: [101.4038, 36.8207],
        新疆: [87.611053, 43.828171],
        西藏: [91.117212, 29.646922],
        四川: [103.9526, 30.7617],
        重庆: [108.384366, 30.439702],
        山东: [117.1582, 36.8701],
        河南: [113.4668, 34.6234],
        江苏: [118.8062, 31.9208],
        安徽: [117.29, 32.0581],
        湖北: [114.3896, 30.6628],
        浙江: [119.5313, 29.8773],
        福建: [119.4543, 25.9222],
        江西: [116.0046, 28.6633],
        湖南: [113.0823, 28.2568],
        贵州: [106.6992, 26.7682],
        云南: [102.9199, 25.4663],
        广东: [113.12244, 23.009505],
        广西: [108.479, 23.1152],
        海南: [110.3893, 19.8516],
        台湾: [120.702967, 24.123621],
        上海: [121.4648, 31.2891],
      }
      return toolTipData.map((item) => {
        return {
          coords: [geoCoordMap[item.name], [geoCoordMap[item.name][0], geoCoordMap[item.name][1] + 1.5]],
        }
      })
    },
    //数据
    scatterData() {
      let toolTipData = [
        {
          name: '湖南',
          value: 5,
          areas: ['长沙', '株洲', '益阳'],
        },
        {
          name: '安徽',
          value: 3,
          areas: ['合肥', '芜湖'],
        },
        {
          name: '河南',
          value: 3,
          areas: ['郑州', '周口'],
        },
        {
          name: '山东',
          value: 80,
          areas: ['济南', '青岛', '淄博', '烟台', '威海', '临沂'],
        },
        {
          name: '四川',
          value: 35,
          areas: ['成都', '攀枝花', '乐山', '泸州'],
        },
        {
          name: '云南',
          value: 27,
          areas: ['昆明', '玉溪', '丽江', '普洱', '临沧'],
        },
        {
          name: '黑龙江',
          value: 13,
          areas: ['哈尔滨', '鹤岗', '黑河', '绥化', '大庆', '佳木斯'],
        },
        {
          name: '甘肃',
          value: 42,
          areas: ['兰州', '嘉峪关', '天水', '酒泉'],
        },
        {
          name: '西藏',
          value: 74,
          areas: [],
        },
      ]
      let geoCoordMap = {
        黑龙江: [127.9688, 45.368],
        内蒙古: [110.3467, 41.4899],
        吉林: [125.8154, 44.2584],
        北京市: [116.4551, 40.2539],
        辽宁: [123.1238, 42.1216],
        河北: [114.4995, 38.1006],
        天津: [117.4219, 39.4189],
        山西: [112.3352, 37.9413],
        陕西: [109.1162, 34.2004],
        甘肃: [103.5901, 36.3043],
        宁夏: [106.3586, 38.1775],
        青海: [101.4038, 36.8207],
        新疆: [87.611053, 43.828171],
        西藏: [91.117212, 29.646922],
        四川: [103.9526, 30.7617],
        重庆: [108.384366, 30.439702],
        山东: [117.1582, 36.8701],
        河南: [113.4668, 34.6234],
        江苏: [118.8062, 31.9208],
        安徽: [117.29, 32.0581],
        湖北: [114.3896, 30.6628],
        浙江: [119.5313, 29.8773],
        福建: [119.4543, 25.9222],
        江西: [116.0046, 28.6633],
        湖南: [113.0823, 28.2568],
        贵州: [106.6992, 26.7682],
        云南: [102.9199, 25.4663],
        广东: [113.12244, 23.009505],
        广西: [108.479, 23.1152],
        海南: [110.3893, 19.8516],
        台湾: [120.702967, 24.123621],
        上海: [121.4648, 31.2891],
      }
      return toolTipData.map((item) => {
        return [geoCoordMap[item.name][0], geoCoordMap[item.name][1] + 2, item]
      })
    },
    //数据2
    convertData(data) {
      let geoCoordMap = {
        黑龙江: [127.9688, 45.368],
        内蒙古: [110.3467, 41.4899],
        吉林: [125.8154, 44.2584],
        北京市: [116.4551, 40.2539],
        辽宁: [123.1238, 42.1216],
        河北: [114.4995, 38.1006],
        天津: [117.4219, 39.4189],
        山西: [112.3352, 37.9413],
        陕西: [109.1162, 34.2004],
        甘肃: [103.5901, 36.3043],
        宁夏: [106.3586, 38.1775],
        青海: [101.4038, 36.8207],
        新疆: [87.611053, 43.828171],
        西藏: [91.117212, 29.646922],
        四川: [103.9526, 30.7617],
        重庆: [108.384366, 30.439702],
        山东: [117.1582, 36.8701],
        河南: [113.4668, 34.6234],
        江苏: [118.8062, 31.9208],
        安徽: [117.29, 32.0581],
        湖北: [114.3896, 30.6628],
        浙江: [119.5313, 29.8773],
        福建: [119.4543, 25.9222],
        江西: [116.0046, 28.6633],
        湖南: [113.0823, 28.2568],
        贵州: [106.6992, 26.7682],
        云南: [102.9199, 25.4663],
        广东: [113.12244, 23.009505],
        广西: [108.479, 23.1152],
        海南: [110.3893, 19.8516],
        台湾: [120.702967, 24.123621],
        上海: [121.4648, 31.2891],
      }
      var res = []
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          })
        }
      }
      return res
    },
    //获取累计分销用户
    get_all_discount_user() {
      //请求方法
      //数据验证
    },
    //分销商品分类排行
    get_discount_cate() {
      //请求方法
      //数据验证
    },
    //获取团队分销排行
    get_team_distributor_list() {
      //请求方法
      //数据验证
    },
    //获取个人分销排行
    get_user_distributor_data() {
      //请求方法
      //数据验证
    },
    //获取大屏数据
    getLargeScreen() {},
    //获取AI答案
    get_AI_data(question) {
      this.AI_dialog_show = 'true'
      this.API_loading = true
      //请求方法
      //数据验证
    },
    //替换问题
    open_AI(index) {
      let res = this.AI_config_data.filter((item) => item.chart_id == index)[0]
      let temporary = ''
      let question = ''
      console.log('question', this.global_charts_data[index]?.chart_options)
      // res.data_type  1.智能报表2.自定义表3.静态数据4.自定义接口
      switch (res.data_type) {
        case '1':
        case '2':
          temporary = this.global_charts_data[index]?.chart_options
          break
        case '3':
          question = res.question_config
          break
        case '4':
          temporary = this[index]
          break
        default:
          break
      }
      if (temporary && res.data_type != 3) {
        question = res.question_config.replace('【数据】', JSON.stringify(temporary))
      }
      this.get_AI_data(question)
    },
    handleResize() {
      let that = this
      this.$nextTick(() => {
        that.screenWidth = window.innerWidth
        that.screenHeight = window.innerHeight
        let screenWidth = that.screenWidth
        let screenHeight = that.screenHeight
        let scale = Math.min(screenWidth / this.designWidth, screenHeight / this.designHeight)
        let horizontalOffset = (screenWidth - this.designWidth * scale) / 2
        let verticalOffset = (screenHeight - this.designHeight * scale) / 2
        that.calculateStyles = {
          transformOrigin: 'top left',
          transform: `translate(${horizontalOffset}px, ${verticalOffset}px) scale(${scale})`,
        }
      })
    },
    getUserAddDataMonth() {
      getUserAddDataMonth().then((response) => {
        this.field_options_8943 = {
          xAxis: {
            data: ['上旬', '中旬', '下旬'],
          },
          series: [
            {
              name: '',
              data: [1, 2, 3],
              type: 'bar',
            },
          ],
        }
        this.initMonthUser(response.data)
      })
    },
    getWeekData() {
      getWeekData().then((response) => {
        this.field_options_216304 = {
          xAxis: {
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
          },
          series: response.data,
        }
      })
    },
    selectUserWear() {
      selectUserWear().then((response) => {
        let data = [
          { name: '平台总用户', value: response.data.total },
          { name: '佩戴设备用户数量', value: response.data.wearCount },
        ]
        this.field_options_470001 = {
          series: [
            {
              data: data,
            },
          ],
        }
      })
    },
    initMonthUser(data) {
      var chartDom = document.getElementById('monthUser')
      var myChart = echarts.init(chartDom)
      var option = {
        tooltip: {
          show: true,
          autoToolTip: false,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'rgba(64, 99, 189, 1)',
            fontSize: 14,
          },
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: false,
          orient: 'horizontal',
          left: 'center',
          top: '',
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '0%',

          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: ['上旬', '中旬', '下旬'],
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6E7079',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 400,
            rotate: 0,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(91, 102, 155, 1)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 400,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        barSetting: {
          barWidth: 19,
          markPoint: {
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                },
              },
            },
            itemStyle: [],
            data: [
              {
                type: 'max',
                name: '最大值',
              },
            ],
            symbol: 'pin',
            symbolSize: 50,
          },
          label: {
            normal: {
              show: true,
              position: 'right',
              fontSize: 16,
              color: '#fff',
            },
          },
          itemStyle: {
            borderRadius: [5, 5, 5, 5],
          },
          markLine: {
            label: {
              color: '#fff',
            },
            symbol: 'none',
            lineStyle: {
              type: 'dashed',
            },
            data: [],
          },
        },
        series: [
          {
            data: data || [],
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#83bff6' }, // 顶部颜色
                { offset: 0.5, color: '#188df0' }, // 中间颜色
                { offset: 1, color: '#188df0' }, // 底部颜色
              ]),
              borderRadius: [6, 6, 0, 0],
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#2378f7' },
                  { offset: 0.7, color: '#2378f7' },
                  { offset: 1, color: '#83bff6' },
                ]),
              },
            },
          },
        ],
      }
      option && myChart.setOption(option)
    },
  },
}
</script>
<style lang="less" scoped>
@import 'https://zhongtai.zhongbenruanjian.com/static/diypaaspc/css/diy-pass-pc.css';
@import '../../assets/diypaaspc/diy-pass-big-screen.css';
@import '../../assets/diypaaspc/library-ant-design-vue.css';

.antdVue {
  position: relative;
  width: 100%;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  background: none;
  background-size: 100% auto !important;
}

.zoom_bg_color {
  background: rgba(2, 8, 15, 0);
}

#antdVue .daping_475_fd0_2_c2_c0_c2_c1 {
  height: 88%;
}

#antdVue .daping_871_fd0_2_c2_c0_c0_c1 {
  height: 85%;
}

#antdVue .daping_947_fd0_2_c1_c0_c2_c0_c0_c1_c0_c0_c0_c0 {
  max-width: 20px;
  max-height: 20px;
}

#antdVue .daping_611_random_fd0_2_c1_c0_c2_c0_c0_c1_c0_c0 {
  text-align: left;
  --header-bg: transparent;
  --header-text-color: rgb(255, 255, 255);
  --header-text-font-size: 16px;
}

#antdVue .daping_718_fd0_2_c1_c0_c2_c0_c0_c1 {
  height: 87%;
  padding: 5px 0px 0px 0px;
}

#antdVue .daping_956_random_fd0_2_c1_c0_c1_c0 {
  height: 200px;
}

#antdVue .daping_550_fd0_2_c1_c0_c0_c1_c0_c1 {
  line-height: 0px;
  font-weight: 800;
  font-family: Source Han Sans SC, Source Han Sans SC;
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.6);
  margin: 14px 0px 0px 0px;
}

#antdVue .daping_757_random_fd0_2_c1_c0_c0_c1_c0_c0 {
  text-align: left;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 800;
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.6);
}

#antdVue .daping_280_fd0_2_c1_c0_c0_c1_c0 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240412/f10971b3729f97aaed38b3611f72dea5.png)
    center center no-repeat;
  width: 140px;
  background-size: 100% 150% !important;
  height: 50px;
}

#antdVue .daping_255_fd0_2_c1_c0_c0_c0 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240418/ffabc4f00a461c2b711f8d271dd3c0cf.png)
    no-repeat;
  width: 250px;
  font-family: Source Han Sans SC, Source Han Sans SC;
}

#antdVue .daping_147_random_fd0_2_c0_c0_c2_c1_c0_c0 {
  border-image-slice: 35 fill;
  border-width: 35px;
  border-style: solid;
  border-color: transparent;
  border-image-source: url(https://ttk-saas.oss-cn-beijing.aliyuncs.com/m2785/border-8.png?v=1723187288358);
}

#antdVue .daping_140_fd0_2_c0_c0_c2 {
  height: 300px;
  margin: -5px 0px 0px 0px;
}

#antdVue .daping_339_random_fd0_2_c0_c0_c1_c1_c0_c0 {
  --chart-title-top: 0px;
}

#antdVue .daping_843_fd0_2_c0_c0_c1_c1 {
  height: 80%;
  padding: 5px 0px 0px 0px;
}

#antdVue .daping_181_fd0_2_c0_c0_c1_c0 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240124/a38d70e7e716c5206e26a079328da07d.png)
    no-repeat;
  height: 48px;
}

#antdVue .daping_298_fd0_2_c0_c0_c0_c1_c1 {
  font-family: Source Han Sans SC, Source Han Sans SC;
  bottom: -5px;
}

#antdVue .daping_288_fd0_2_c0_c0_c0_c1_c0_c1 {
  line-height: 0px;
  font-weight: 800;
  font-family: Source Han Sans SC, Source Han Sans SC;
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.6);
}

#antdVue .daping_544_random_fd0_2_c0_c0_c0_c1_c0_c0 {
  font-weight: 800;
  text-shadow: 0px 3px 3px rgba(0, 0, 0, 0.6);
}

#antdVue .daping_851_fd0_2_c0_c0_c0_c1_c0 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240412/f10971b3729f97aaed38b3611f72dea5.png)
    center center no-repeat;
  width: 140px;
  background-size: 100% 150% !important;
}

#antdVue .daping_419_fd0_2_c0_c0_c0_c1 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240418/ffabc4f00a461c2b711f8d271dd3c0cf.png)
    no-repeat;
  height: 260%;
  font-family: Source Han Sans SC, Source Han Sans SC;
}

#antdVue .daping_854_fd0_2_c0_c0_c0_c0_c0 {
  font-family: D-DIN-PRO-400-Regular;
}

#antdVue .daping_704_fd0_2_c0_c0_c0_c0 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240124/a38d70e7e716c5206e26a079328da07d.png)
    no-repeat;
}

#antdVue .daping_692_fd0_2_c0_c0_c0 {
  height: 300px;
}

#antdVue .daping_900_random_fd0_1_c5 {
  width: 70px;
  height: 70px;
  --full-screen-color: rgba(255, 255, 255, 1);
  --full-screen-width: 35px;
  --full-screen-height: 35px;
  top: 28px;
  right: 100px;
  z-index: 99;
}

#antdVue .daping_708_random_fd0_1_c4_c1 {
  color: rgba(255, 255, 255, 1);
}

#antdVue .daping_210_fd0_1_c4_c0 {
  width: 32px;
  height: 32px;
  border-radius: 0px 0px 0px 0px;
  margin: 0px 8px 0px 0px;
}

#antdVue .daping_958_fd0_1_c4 {
  width: 300px;
  top: 38px;
  right: 180px;
  height: 50px;
}

#antdVue .daping_542_fd0_1_c3 {
  width: 48px;
  height: 48px;
  border-radius: 0px 0px 0px 0px;
  margin: 0px 0px 0px 8px;
}

#antdVue .daping_495_fd0_1_c1 {
  width: 48px;
  height: 48px;
  margin: 0px 8px 0px 0px;
}

#antdVue .daping_904_fd0_1_c0_c3 {
  margin: 0px 0px 0px 8px;
  line-height: 10px;
}

#antdVue .daping_556_fd0_1_c0_c2 {
  background: linear-gradient(180deg, rgba(216, 226, 255, 0) 0%, #e3eaff 49%, rgba(216, 226, 255, 0) 100%);
  width: 2px;
  height: 16px;
  margin: 0px 0px 0px 8px;
}

#antdVue .daping_848_fd0_1_c0_c1 {
  margin: 0px 0px 0px 8px;
}

#antdVue .daping_627_fd0_1_c0_c0 {
  width: 32px;
  height: 32px;
  border-radius: 0px 0px 0px 0px;
}

#antdVue .daping_724_fd0_1_c0 {
  top: 38px;
  left: 100px;
  height: 50px;
}
#antdVue .joefitdaping_435_random_fd0_1_c1_c0_c0_c0_c0_c0 {
  font-size: 42px;
  font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
}
#antdVue .daping_659_fd0_1 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240124/95867b2fe8e71f9cd1cf14259ed09824.png)
    no-repeat;
  font-size: 48px;
  height: 135px;
  font-weight: 800;
}

.zoom_bg_color {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240218/28580720a4073072604131817b3e36d2.png)
    center / 100% 100% no-repeat !important;
  overflow: hidden;
}

#antdVue #map {
  height: 850px;
  width: 1120px;
}
.chart-border {
  border: solid 1px #70a5c7;
}

#antdVue .joefitdaping_625_fd0_1_c1_c0 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/cfb7f7a0d0e6c70741804b5b1b3df482.png)
    no-repeat;
  height: 600px;
}
</style>